import { ConfigContext } from "../../../contexts/ConfigContext";
import { devConsoleLog } from "../../../utils/devConsoleLog";
import { TextValue } from "nemuru-components";
import { useContext } from "react";
import { developOptions } from "../../../config/developOptions";

export default function Text(props) {
  const { tId } = props;
  const {
    state: { dictionaryValues },
  } = useContext(ConfigContext);
  const textId = tId || props.children;
  const translation = dictionaryValues[tId] || dictionaryValues[props.children];
  const result = TextValue({
    tId: textId,
    translation: translation,
    originalTextId: true,
    ...props,
  });
  if (!translation && developOptions.SHOW_MISSING_TRANSLATIONS_IN_LOG) {
    devConsoleLog(
      `--- Translation param needed: */\n  ${textId}: '${result}️', \n/* --- in current language file`
    );
    devConsoleLog(result);
  }
  if (result === undefined) {
    console.error("Text result is undefined", props);
  }
  return result ?? null;
}
